import React from 'react';
import { Range } from 'react-range';
import { formatNumber } from '@/utils';
import { cn } from '@/utils/cn';
import TextSmall from '../Typography/TextSmall';
import TextBase from '../Typography/TextBase';

function RangeSlider({
  min = 0,
  max = 100,
  step = 1,
  values,
  onChange = () => {},
  valueChanged = false,
}) {
  if (max < min) {
    return null;
  }

  return (
    <div className="range-slider w-full max-w-lg mx-auto">
      <div className="">
        <Range
          values={values}
          step={step}
          min={min}
          max={max}
          onChange={onChange}
          renderTrack={({ props, children }) => (
            <div
              {...props}
              key={1}
              className="h-[2px] lg:h-[6px] bg-gray-300 relative"
              style={{
                background: `linear-gradient(to right, #BEC7D5 ${((values[0] - min) / (max - min)) * 100}%, 
              #DB0032 ${((values[0] - min) / (max + 1 - min)) * 100}%, 
              #DB0032 ${((values[1] - min) / (max + 1 - min)) * 100}%, 
             #BEC7D5 ${((values[1] - min) / (max + 1 - min)) * 100}%)`,
              }}
            >
              {children}
            </div>
          )}
          renderThumb={({ props }) => (
            <div
              {...props}
              key={props?.key}
              className={cn(
                'range-thumb size-[20px] lg:size-[24px] bg-richcarmine rounded-full focus:!outline-none shadow-none',
                {
                  '!shadow-compare-bottom-action': valueChanged,
                },
              )}
            />
          )}
        />
      </div>

      <div className="range-values flex justify-between mt-14 mb-12 lg:mb-16">
        <TextSmall
          text={`৳ ${formatNumber(values[0])}`}
          className="text-senate font-semibold"
        />
        <TextSmall
          text={`৳ ${formatNumber(values[1])}`}
          className="text-senate font-semibold"
        />
      </div>

      <div className="selected-range-values">
        <TextSmall
          text="Selected:"
          className="inline-block text-senate font-medium"
        />
        <TextBase
          text={`৳ ${formatNumber(values[0])} - ৳ ${formatNumber(values[1])}`}
          className="inline-block text-richcarmine font-semibold whitespace-nowrap ml-8"
        />
      </div>
    </div>
  );
}

export default RangeSlider;
